var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTollgate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 38.306,
    viewBox: "0 0 50 38.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-165 -412.909)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M215,428.348a.91.91,0,0,0-.08.171,3.882,3.882,0,0,1-3.968,3.148q-12.057.005-24.113,0h-6.179v16.408h.519q3.148,0,6.3,0a1.572,1.572,0,1,1-.008,3.124c-6.817,0-13.635-.011-20.452.014A1.917,1.917,0,0,1,165,450.03V436.747a4.489,4.489,0,0,1,.629-.842,1.4,1.4,0,0,1,1.6-.172,1.552,1.552,0,0,1,.895,1.5q0,5.127,0,10.254v.561h9.345V431.668c-.759,0-1.488,0-2.218,0a3.9,3.9,0,0,1-4-4.02c-.007-1.449,0-2.9,0-4.346a3.912,3.912,0,0,1,4.13-4.135c.694,0,1.388,0,2.119,0,0-.721,0-1.385,0-2.049,0-.832-.243-1.076-1.072-1.076H169.25c-.9,0-1.125.224-1.125,1.12q0,6.64,0,13.281c0,1.146-.377,1.758-1.21,1.965-.773.192-1.391-.173-1.915-1.13V416.237a.93.93,0,0,0,.08-.172A3.883,3.883,0,0,1,169,412.919c2.554-.008,5.108-.022,7.662.014a4.271,4.271,0,0,1,1.65.347,3.736,3.736,0,0,1,2.309,3.5c.031.789.005,1.579.005,2.392H210.46c2.567,0,3.738.854,4.506,3.286,0,.014.022.023.034.035Zm-25.673-6.055c-1.9,0-3.69-.008-5.476.013a.881.881,0,0,0-.519.283q-2.8,2.781-5.589,5.58c-.1.1-.184.2-.339.375h.517c1.576,0,3.153-.007,4.729.006a.967.967,0,0,0,.767-.308c1.829-1.848,3.672-3.682,5.51-5.521C189.037,422.608,189.142,422.49,189.327,422.293Zm10.191,0c-1.865,0-3.585.008-5.3-.007a.968.968,0,0,0-.763.318q-2.745,2.771-5.51,5.521c-.11.11-.211.228-.363.392.126.014.184.025.242.025,1.722,0,3.445.009,5.167-.011a.876.876,0,0,0,.53-.258c.908-.884,1.8-1.786,2.7-2.682Zm10.156,0c-1.958,0-3.773-.005-5.589.01a.691.691,0,0,0-.4.232q-2.868,2.855-5.723,5.722a2.657,2.657,0,0,0-.21.285c1.855,0,3.642,0,5.429-.007a.6.6,0,0,0,.381-.153C205.573,426.393,207.571,424.394,209.674,422.293Zm-30.6,0c-1.3,0-2.588-.009-3.872,0a.773.773,0,0,0-.821.878c-.009.911,0,1.821,0,2.732v1.078Zm28.921,6.222c-.026-.032-.007.012.012.012,1.057.005,2.115.025,3.171,0a.665.665,0,0,0,.677-.654c.032-1.081.011-2.163.011-3.22Z",
    fill: "#2e8ed0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M376.592,686.125a1.561,1.561,0,1,1,1.54-1.57A1.575,1.575,0,0,1,376.592,686.125Z",
    transform: "translate(-182.666 -234.925)",
    fill: "#2e8ed0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M212.994,580.045c0-1.107,0-2.213,0-3.32a1.569,1.569,0,1,1,3.123-.026q.006,3.369,0,6.737a1.569,1.569,0,1,1-3.123-.023C212.992,582.29,212.994,581.168,212.994,580.045Z",
    transform: "translate(-41.744 -140.978)",
    fill: "#2e8ed0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTollgate);
export default __webpack_public_path__ + "static/media/tollgate.6a4a2f9bb82e73386a4e3311fc75fe96.svg";
export { ForwardRef as ReactComponent };